<woa-modal-page-layout [title]="title()"
                       [translationParams]="{'minimumAge': orderingContextModel.currentStore().rsaMinimumAge}">
    @if (configurationModel.isConsumerActor()) {
        <div class="age-indicator">
            {{ 'woa.message.rsa-verification.minimumAge' | translate: {'minimumAge': orderingContextModel.currentStore().rsaMinimumAge} }}
        </div>
        <woa-legal-panel class="rsa-legal"
                         [messageSet]="'rsa-verification'"
                         [messageParams]="{'minimumAge': orderingContextModel.currentStore().rsaMinimumAge}"></woa-legal-panel>
        <div class="rsa-disclaimer">
            {{ 'woa.message.rsa-verification.disclaimer' | translate }}
        </div>
    } @else {
        <woa-icon class="rsa-indicator" [name]="'no-alcohol'"></woa-icon>
        <div class="rsa-acknowledgement"
             [innerHTML]="'woa.message.rsa-verification.acknowledgement' | translate: {'tableNumber': this.orderingContextModel.currentTableNumberLabel()}">
        </div>
    }
    <woa-button woa-page-footer-control
                [prominence]="ButtonProminence.LOW"
                [label]="cancelButtonLabel()"
                [translationParams]="{minimumAge: orderingContextModel.currentStore().rsaMinimumAge}"
                (onActivate)="dismiss()"></woa-button>
    <woa-button woa-page-footer-control
                [label]="proceedButtonLabel()"
                [translationParams]="{minimumAge: orderingContextModel.currentStore().rsaMinimumAge}"
                (onActivate)="dismiss(true)"></woa-button>
</woa-modal-page-layout>
